/* ============================================
   Global JavaScript
   ============================================ */

// Shopify formatMoney helper
if (typeof Shopify === 'undefined') {
  var Shopify = {};
}

Shopify.formatMoney = function(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Cart AJAX functionality
Shopify.onCartUpdate = function(cart) {
  // Update cart count in header
  const cartCountElements = document.querySelectorAll('[data-cart-count]');
  cartCountElements.forEach(el => {
    el.textContent = cart.item_count;
    if (cart.item_count > 0) {
      el.classList.add('has-items');
    } else {
      el.classList.remove('has-items');
    }
  });
  
  // Open cart drawer if exists
  if (typeof window.openCartDrawer === 'function') {
    window.openCartDrawer();
  }
};

// Add to cart AJAX for product forms
document.addEventListener('DOMContentLoaded', function() {
  // Product form AJAX (delegated to catch dynamically rendered forms)
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;

    // Allow dynamic checkout / buy now buttons to submit normally
    const submitter = e.submitter;
    if (submitter) {
      if (
        submitter.name === 'checkout' ||
        submitter.classList.contains('shopify-payment-button__button') ||
        submitter.closest('.shopify-payment-button')
      ) {
        return;
      }
    }

    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    const submitText = submitBtn.querySelector('span') || submitBtn;
    const originalText = submitText.textContent;

    submitBtn.disabled = true;
    submitText.textContent = 'Adding...';

    const formData = new FormData(form);

    fetch(form.action + '.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
    .then(response => {
      if (!response.ok) throw new Error('Status ' + response.status);
      return response.json();
    })
    .then(data => {
      return fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    })
    .then(response => response.json())
    .then(cart => {
      Shopify.onCartUpdate(cart);
      submitText.textContent = 'Added!';

      setTimeout(() => {
        submitBtn.disabled = false;
        submitText.textContent = originalText;
      }, 2000);
    })
    .catch(error => {
      console.error('Add to cart error:', error);
      // Fallback: submit form normally (lets the browser handle auth)
      submitBtn.disabled = false;
      submitText.textContent = originalText;
      form.submit();
    });
  });
  
  // Accordion functionality
  document.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
    trigger.addEventListener('click', function() {
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('is-open');
      
      // Close all other items
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('is-open'));
      
      // Toggle current item
      if (!isOpen) {
        item.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      } else {
        this.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // Deal countdowns
  const countdownElements = Array.from(document.querySelectorAll('[data-deal-end]'));
  if (countdownElements.length) {
    const updateCountdowns = () => {
      const now = new Date().getTime();
      countdownElements.forEach((el) => {
        const end = new Date(el.dataset.dealEnd).getTime();
        if (Number.isNaN(end)) return;
        const diff = Math.max(end - now, 0);
        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        el.textContent = `Ends in ${days} days ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      });
    };

    updateCountdowns();
    setInterval(updateCountdowns, 1000);
  }
});

// Cart drawer functions (can be overridden by cart-drawer.liquid)
window.openCartDrawer = window.openCartDrawer || function() {
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
};

window.closeCartDrawer = window.closeCartDrawer || function() {
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }
};
